import React, { useState } from "react";
import './CategoryDetailsContent.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faCrown, faCloudSun, faDroplet } from "@fortawesome/free-solid-svg-icons";

const CategoryDetailsContent = () => {
    const [activeTip, setActiveTip] = useState(0);
    const [mainImage, setMainImage] = useState("images/Group 102.png"); // Initial main image
    const [secondaryImages, setSecondaryImages] = useState([
        "images/flower-1.png",
        "images/flower-6.png",
        "images/flower-4.png",
        "images/flower-7.png"
    ]);

    const handleImageClick = (clickedImage, index) => {
        setMainImage(clickedImage);
        const updatedSecondaryImages = [...secondaryImages];
        updatedSecondaryImages[index] = mainImage; 
        setSecondaryImages(updatedSecondaryImages);
    };

    return (
        <div>
        <div className='row px-md-5 py-5 px-3'>
            <div className="col-md-6">
                <h3 className='secondary-color'>Aglaonema plant in a round glass bowl</h3>
                <h5 className='my-3' style={{ color: "#3B434F" }}>50.5$</h5>
                <div className="d-flex">
                    <div className="p-2 px-3 rounded-start-4 hovers number-border"><FontAwesomeIcon icon={faMinus} /></div>
                    <div className="p-2 px-3 number-border">1</div>
                    <div className="p-2 px-3 rounded-end-4 hovers number-border"><FontAwesomeIcon icon={faPlus} /></div>
                </div>
                <p className="review-text mt-3 mb-4 pb-1">Aglaonema plant in a circular glass basin, is considered one of the beautiful plants that purify the air. It is characterized by its wavy green leaves. It does not require much care, and can be placed in homes or various work environments.</p>
                <span className="add-to-card text-white px-3 py-2 rounded-4 hovers">Add To Card</span>
                <div className="tips">
                    <div className="d-flex gap-3 align-items-center my-4">
                        <div className={`tip-btn p-3 text-center h-100 rounded-4 ${activeTip === 0 ? "active" : ""}`}
                            onClick={() => setActiveTip(0)}>
                            <FontAwesomeIcon icon={faCrown} />
                            <h6 className='m-0'>Water</h6>
                        </div>
                        <div className={`tip-btn p-3 text-center h-100 rounded-4 ${activeTip === 1 ? "active" : ""}`}
                            onClick={() => setActiveTip(1)}>
                            <FontAwesomeIcon icon={faCloudSun} />
                            <h6 className='m-0'>Part Sun</h6>
                        </div>
                        <div className={`tip-btn p-3 text-center h-100 rounded-4 ${activeTip === 2 ? "active" : ""}`}
                            onClick={() => setActiveTip(2)}>
                            <FontAwesomeIcon icon={faDroplet} />
                            <h6 className='m-0'>Medium</h6>
                        </div>
                    </div>
                    <div>
                        <div className={`tip-desc ${activeTip === 0 ? "" : "d-none"}`}>
                            <div className="d-flex align-items-center gap-2">
                                <img src="images/mdi_irrigation.png" alt="" />
                                <h5 className='m-0 tip-title'>Irrigation</h5>
                            </div>
                            <p className="review-text my-2">
                                The plant should not be watered until the soil is partially dry, and it is preferable to spray its leaves with water to provide moisture.
                            </p>
                        </div>
                        <div className={`tip-desc ${activeTip === 1 ? "" : "d-none"}`}>
                            <div className="d-flex align-items-center gap-2">
                                <img src="images/mdi_irrigation.png" alt="" />
                                <h5 className='m-0 tip-title'>Irrigation-2</h5>
                            </div>
                            <p className="review-text my-2">
                                The plant should not be watered until the soil is partially dry, and it is preferable to spray its leaves with water to provide moisture.
                            </p>
                        </div>
                        <div className={`tip-desc ${activeTip === 2 ? "" : "d-none"}`}>
                            <div className="d-flex align-items-center gap-2">
                                <img src="images/mdi_irrigation.png" alt="" />
                                <h5 className='m-0 tip-title'>Irrigation-3</h5>
                            </div>
                            <p className="review-text my-2">
                                The plant should not be watered until the soil is partially dry, and it is preferable to spray its leaves with water to provide moisture.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 text-center">
                <img src={mainImage} className="img-fluid w-100 rounded shadow-lg main-img" alt="Main" />
                <div className="d-flex gap-3 mt-3">
                    {secondaryImages.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            className="img-fluid w-25 rounded shadow-lg sec-img"
                            alt={`Secondary ${index + 1}`}
                            onClick={() => handleImageClick(image, index)}
                        />
                    ))}
                </div>
            </div>
        </div>
        <div className="m-md-5 m-3 d-flex justify-content-between flex-wrap gap-2">
            <div className="btn-main-bg hovers p-1 text-white rounded-pill">Water</div>
            <div className="btn-outline-main p-1 rounded-pill">Light</div>
            <div className="btn-outline-main p-1 rounded-pill">Humidity</div>
            <div className="btn-outline-main p-1 rounded-pill">Problems & Pests</div>
            <div className="btn-outline-main p-1 rounded-pill">Fretilizing</div>
            <div className="btn-outline-main p-1 rounded-pill">Temperature</div>
            <div className="btn-outline-main p-1 rounded-pill">Solid & Repotting</div>
            <div className="btn-outline-main p-1 rounded-pill">Characteristics</div>
        </div>
        <div className="row align-items-center px-md-5 py-5 px-3">
            <div className="col-md-6">                                
                <h3 className='secondary-color'>Description</h3>
                <p className="review-text mt-3 mb-4 pb-1">Aglaonema plant in a circular glass basin, is considered one of the beautiful plants that purify the air. It is characterized by its wavy green leaves. It does not require much care, and can be placed in homes or various work environments.</p>
                <p className="befored-effect p-2">Plant height with basin 35 cm</p>
                <p className="befored-effect p-2">Basin width 10 cm</p>
                <p className="befored-effect p-2">There is no drain hole under the sink.</p>
            </div>
            <div className="col-md-6">
                <img src='images/Group 102.png' className="img-fluid w-100 rounded shadow-lg main-img" alt="Main" />
            </div>
        </div>
        </div>
    );
};

export default CategoryDetailsContent;
